import ADDON_DELIVERY_MODES from '@constants/addonDeliveryModes';

import GTM_ITEM_CATEGORIES from '../constants/gtmItemCategories';
import GTM_ITEM_XML_CATEGORIES from '../constants/gtmItemXmlCategories';

const convertDietAddonToGtmItem = ({
  brandName,
  dietDaysLength,
  dietAddon: { addon, type, quantity },
}) => ({
  // eslint-disable-next-line camelcase -- FIXME
  item_id: `${addon.id}`,
  // eslint-disable-next-line camelcase -- FIXME
  item_xml_id: `${GTM_ITEM_XML_CATEGORIES.addon}_${addon.id}`,
  // eslint-disable-next-line camelcase -- FIXME
  item_name: addon.name,
  coupon: '',
  discount: 0,
  index: 0,
  // eslint-disable-next-line camelcase -- FIXME
  item_brand: brandName,
  // eslint-disable-next-line camelcase -- FIXME
  item_category: GTM_ITEM_CATEGORIES.addon,
  // eslint-disable-next-line camelcase -- FIXME
  item_category2: '',
  // eslint-disable-next-line camelcase -- FIXME
  item_category3: '',
  // eslint-disable-next-line camelcase -- FIXME
  item_category4: '',
  // eslint-disable-next-line camelcase -- FIXME
  item_category5: '',
  // eslint-disable-next-line camelcase -- FIXME
  item_category6: false,
  // eslint-disable-next-line camelcase -- FIXME
  item_category7: 0,
  // eslint-disable-next-line camelcase -- FIXME
  item_category8: '',
  // eslint-disable-next-line camelcase -- FIXME
  item_category9: '',
  // eslint-disable-next-line camelcase -- FIXME
  item_category10: '',
  // eslint-disable-next-line camelcase -- FIXME
  item_category11: '',
  // eslint-disable-next-line camelcase -- FIXME
  item_category12: type,
  price: addon.clientCost,
  quantity: Math.abs(quantity),
  duration: type === ADDON_DELIVERY_MODES.FOR_FIRST_BAG ? 1 : dietDaysLength,
});

export default convertDietAddonToGtmItem;
